import { useContext } from "react";

import { ThemeContext } from "styled-components";

import { Theme } from "../../styles/colors/types";

export const useTheme = (): Theme => {
  const theme = useContext(ThemeContext);

  if (!theme) {
    throw new Error("ThemeProvider required to access theme");
  }

  return theme;
};
